import { fetchCurrentUser } from '../../ducks/user.duck';
import { onGroupFolderCollectionCreate, onGroupFolderCollectionFind, onGroupFolderCollectionUpdate, onGroupFolderDocumentCollectionFind, onGroupFolderDocumentCollectionUpdate, onGroupPaymentCollectionCreate, onGroupPaymentCollectionFind, onGroupPaymentCollectionUpdate } from '../../util/api';
import { storableError } from '../../util/errors';
import { resolveGroupPageTab } from '../../util/groupPageTabRouting';
import {
  GROUP_PAGE_TAB_DOCUMENTS,
  GROUP_PAGE_TAB_PAYMENTS,
  GROUP_PAYMENT_STATUS_ACTIVE,
} from '../../util/types';
import { parse } from '../../util/urlHelpers';
import { fetchAdminModerator } from '../AdminPanelModeratorsPage/AdminPanelModeratorsPage.duck';
import {
  fetchGroupHighlightsStatus,
  fetchSpaceList,
  getCurrentUserCircleAuthParams,
  getSpaceDetails,
  requestSpaceDetails,
  setInitalLoadToken,
  toggleCreateComment,
} from '../CircleCommunityPage/CircleCommunityPage.duck';
import { findGroupJoin } from '../DiscoverGroupsCommunityPage/DiscoverGroupsCommunityPage.duck';

export const REQUEST_SPACE_DETAILS = 'app/MyGroupPage/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/MyGroupPage/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/MyGroupPage/ERROR_SPACE_DETAILS';

export const CREATE_FOLDER_REQUEST = 'app/MyGroupPage/CREATE_FOLDER_REQUEST';
export const CREATE_FOLDER_SUCCESS = 'app/MyGroupPage/CREATE_FOLDER_SUCCESS';
export const CREATE_FOLDER_ERROR = 'app/MyGroupPage/CREATE_FOLDER_ERROR';

export const UPDATE_FOLDER_REQUEST = 'app/MyGroupPage/UPDATE_FOLDER_REQUEST';
export const UPDATE_FOLDER_SUCCESS = 'app/MyGroupPage/UPDATE_FOLDER_SUCCESS';
export const UPDATE_FOLDER_ERROR = 'app/MyGroupPage/UPDATE_FOLDER_ERROR';

export const FETCH_FOLDER_REQUEST = 'app/MyGroupPage/FETCH_FOLDER_REQUEST';
export const FETCH_FOLDER_SUCCESS = 'app/MyGroupPage/FETCH_FOLDER_SUCCESS';
export const FETCH_FOLDER_ERROR = 'app/MyGroupPage/FETCH_FOLDER_ERROR';

export const UPDATE_FOLDER_DOCUMENT_REQUEST = 'app/MyGroupPage/UPDATE_FOLDER_DOCUMENT_REQUEST';
export const UPDATE_FOLDER_DOCUMENT_SUCCESS = 'app/MyGroupPage/UPDATE_FOLDER_DOCUMENT_SUCCESS';
export const UPDATE_FOLDER_DOCUMENT_ERROR = 'app/MyGroupPage/UPDATE_FOLDER_DOCUMENT_ERROR';

export const FETCH_FOLDER_DOCUMENT_REQUEST = 'app/MyGroupPage/FETCH_FOLDER_DOCUMENT_REQUEST';
export const FETCH_FOLDER_DOCUMENT_SUCCESS = 'app/MyGroupPage/FETCH_FOLDER_DOCUMENT_SUCCESS';
export const FETCH_FOLDER_DOCUMENT_ERROR = 'app/MyGroupPage/FETCH_FOLDER_DOCUMENT_ERROR';

export const FETCH_GROUP_PAYMENT_REQUEST = 'app/MyGroupPage/FETCH_GROUP_PAYMENT_REQUEST';
export const FETCH_GROUP_PAYMENT_SUCCESS = 'app/MyGroupPage/FETCH_GROUP_PAYMENT_SUCCESS';
export const FETCH_GROUP_PAYMENT_ERROR = 'app/MyGroupPage/FETCH_GROUP_PAYMENT_ERROR';

export const CREATE_GROUP_PAYMENT_REQUEST = 'app/MyGroupPage/CREATE_GROUP_PAYMENT_REQUEST';
export const CREATE_GROUP_PAYMENT_SUCCESS = 'app/MyGroupPage/CREATE_GROUP_PAYMENT_SUCCESS';
export const CREATE_GROUP_PAYMENT_ERROR = 'app/MyGroupPage/CREATE_GROUP_PAYMENT_ERROR';

export const UPDATE_GROUP_PAYMENT_REQUEST = 'app/MyGroupPage/UPDATE_GROUP_PAYMENT_REQUEST';
export const UPDATE_GROUP_PAYMENT_SUCCESS = 'app/MyGroupPage/UPDATE_GROUP_PAYMENT_SUCCESS';
export const UPDATE_GROUP_PAYMENT_ERROR = 'app/MyGroupPage/UPDATE_GROUP_PAYMENT_ERROR';


const initialState = {
  requestSpaceDetails: false,
  spaceDetailsData: null,
  errorSpaceDetails: null,
  createFolderRequest: false,
  createFolderError: false,
  updateFolderRequest: false,
  updateFolderError: false,
  fetchFolderRequest: false,
  fetchFolderError: false,
  allGroupFolders: null,
  fetchFolderDocumentRequest: false,
  fetchFolderDocumentError: false,
  allFolderDocuments: null,
  updateFolderDocumentRequest: false,
  updateFolderDocumentError: false,
  totalDocumentCount: 0,
  fetchGroupPaymentRequest: false,
  fetchGroupPaymentError: false,
  allGroupPayments: null,
  createGroupPaymentRequest: false,
  createGroupPaymentError: false,
  updateGroupPaymentRequest: false,
  updateGroupPaymentError: false,
};

export const FOLDER_DOCUMENT_PAGE_SIZE = 5;
export const GROUP_PAYMENT_PAGE_SIZE = 5;

export default function myGroupPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: true };
    case SUCCESS_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: false, spaceDetailsData: payload.data };
    case ERROR_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        spaceDetailsData: null,
        errorSpaceDetails: payload.error,
      };

    case CREATE_FOLDER_REQUEST:
      return { ...state, createFolderRequest: payload, createFolderError: null };
    case CREATE_FOLDER_SUCCESS:
      return { ...state, createFolderRequest: false, createFolderError: null };
    case CREATE_FOLDER_ERROR:
      return {
        ...state,
        createFolderRequest: false,
        createFolderError: true,
      };

    case UPDATE_FOLDER_REQUEST:
      return { ...state, updateFolderRequest: payload, updateFolderError: null };
    case UPDATE_FOLDER_SUCCESS:
      return { ...state, updateFolderRequest: false, updateFolderError: null };
    case UPDATE_FOLDER_ERROR:
      return {
        ...state,
        updateFolderRequest: false,
        updateFolderError: true,
      };

    case FETCH_FOLDER_REQUEST:
      return { ...state, fetchFolderRequest: true, fetchFolderError: null };
    case FETCH_FOLDER_SUCCESS:
      return {
        ...state,
        fetchFolderRequest: false,
        fetchFolderError: null,
        allGroupFolders: payload.data,
        totalDocumentCount: payload.pagination?.documentCount ?? 0,
      };
    case FETCH_FOLDER_ERROR:
      return {
        ...state,
        fetchFolderRequest: false,
        fetchFolderError: true,
      };

    case UPDATE_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state, updateFolderDocumentRequest: payload,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, updateFolderDocumentRequest: false,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        updateFolderDocumentRequest: false,
        updateFolderDocumentError: true,
      };

    case FETCH_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state,
        fetchFolderDocumentRequest: true,
        fetchFolderDocumentError: false,
        allFolderDocuments: null,
      };
    case FETCH_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: false,
        allFolderDocuments: payload,
      };
    case FETCH_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: true,
        allFolderDocuments: null,
      };

    case UPDATE_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state, updateFolderDocumentRequest: payload,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, updateFolderDocumentRequest: false,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        updateFolderDocumentRequest: false,
        updateFolderDocumentError: true,
      };

    case FETCH_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state,
        fetchFolderDocumentRequest: true,
        fetchFolderDocumentError: false,
        allFolderDocuments: null,
      };
    case FETCH_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: false,
        allFolderDocuments: payload,
      };
    case FETCH_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: true,
        allFolderDocuments: null,
      };

    case FETCH_GROUP_PAYMENT_REQUEST:
      return { ...state, fetchGroupPaymentRequest: true, fetchGroupPaymentError: false, allGroupPayments: null };
    case FETCH_GROUP_PAYMENT_SUCCESS:
      return { ...state, fetchGroupPaymentRequest: false, fetchGroupPaymentError: false, allGroupPayments: payload };
    case FETCH_GROUP_PAYMENT_ERROR:
      return { ...state, fetchGroupPaymentRequest: false, fetchGroupPaymentError: true, allGroupPayments: null };

    case CREATE_GROUP_PAYMENT_REQUEST:
      return { ...state, createGroupPaymentRequest: payload, createGroupPaymentError: false };
    case CREATE_GROUP_PAYMENT_SUCCESS:
      return { ...state, createGroupPaymentRequest: false, createGroupPaymentError: false };
    case CREATE_GROUP_PAYMENT_ERROR:
      return { ...state, createGroupPaymentRequest: false, createGroupPaymentError: true };

    case UPDATE_GROUP_PAYMENT_REQUEST:
      return { ...state, updateGroupPaymentRequest: payload, updateGroupPaymentError: false };
    case UPDATE_GROUP_PAYMENT_SUCCESS:
      return { ...state, updateGroupPaymentRequest: false, updateGroupPaymentError: false };
    case UPDATE_GROUP_PAYMENT_ERROR:
      return { ...state, updateGroupPaymentRequest: false, updateGroupPaymentError: true };

      default:
      return state;
  }
}

// export const requestSpaceDetails = () => ({
//   type: REQUEST_SPACE_DETAILS,
// });
export const successSpaceDetails = data => ({
  type: SUCCESS_SPACE_DETAILS,
  payload: { data },
});
export const errorSpaceDetails = error => ({
  type: ERROR_SPACE_DETAILS,
  payload: { error },
});


export const createFolderRequest = (data) => ({
  type: CREATE_FOLDER_REQUEST,
  payload: data,
});
export const createFolderSuccess = data => ({
  type: CREATE_FOLDER_SUCCESS,
  payload: data,
});
export const createFolderError = error => ({
  type: CREATE_FOLDER_ERROR,
  payload: error,
});

export const updateFolderRequest = (data) => ({
  type: UPDATE_FOLDER_REQUEST,
  payload: data,
});
export const updateFolderSuccess = data => ({
  type: UPDATE_FOLDER_SUCCESS,
  payload: data,
});
export const updateFolderError = error => ({
  type: UPDATE_FOLDER_ERROR,
  payload: error,
});

export const fetchFolderRequest = () => ({
  type: FETCH_FOLDER_REQUEST,
});
export const fetchFolderSuccess = data => ({
  type: FETCH_FOLDER_SUCCESS,
  payload: data,
});
export const fetchFolderError = error => ({
  type: FETCH_FOLDER_ERROR,
  payload: error,
});


export const fetchFolderDocumentRequest = () => ({
  type: FETCH_FOLDER_DOCUMENT_REQUEST,
});
export const fetchFolderDocumentSuccess = data => ({
  type: FETCH_FOLDER_DOCUMENT_SUCCESS,
  payload: data,
});
export const fetchFolderDocumentError = error => ({
  type: FETCH_FOLDER_DOCUMENT_ERROR,
  payload: error,
});

export const updateFolderDocumentRequest = (data) => ({
  type: UPDATE_FOLDER_DOCUMENT_REQUEST,
  payload: data,
});
export const updateFolderDocumentSuccess = data => ({
  type: UPDATE_FOLDER_DOCUMENT_SUCCESS,
  payload: data,
});
export const updateFolderDocumentError = error => ({
  type: UPDATE_FOLDER_DOCUMENT_ERROR,
  payload: error,
});

export const fetchGroupPaymentRequest = () => ({
  type: FETCH_GROUP_PAYMENT_REQUEST,
});
export const fetchGroupPaymentSuccess = data => ({
  type: FETCH_GROUP_PAYMENT_SUCCESS,
  payload: data,
});

export const fetchGroupPaymentError = error => ({
  type: FETCH_GROUP_PAYMENT_ERROR,
  payload: error,
});

export const createGroupPaymentRequest = (payload) => ({
  type: CREATE_GROUP_PAYMENT_REQUEST,
  payload:payload
});
export const createGroupPaymentSuccess = data => ({
  type: CREATE_GROUP_PAYMENT_SUCCESS,
  payload: data,
});

export const createGroupPaymentError = error => ({
  type: CREATE_GROUP_PAYMENT_ERROR,
  payload: error,
});

export const updateGroupPaymentRequest = (data) => ({
  type: UPDATE_GROUP_PAYMENT_REQUEST,
  payload:data
});
export const updateGroupPaymentSuccess = data => ({
  type: UPDATE_GROUP_PAYMENT_SUCCESS,
  payload: data,
});
export const updateGroupPaymentError = error => ({
  type: UPDATE_GROUP_PAYMENT_ERROR,
  payload: error,
});


export const fetchGroupPayment = (params,data) => async (dispatch, getState) => {
  dispatch(fetchGroupPaymentRequest());
  return onGroupPaymentCollectionFind({...params, data })
    .then((response) => {
      dispatch(fetchGroupPaymentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "fetchGroupPayment >>>> storableError(e)")
      dispatch(fetchGroupPaymentError(storableError(e)));
    });
};

export const createGroupPayment = (params,type) => async (dispatch, getState) => {
  dispatch(createGroupPaymentRequest(type));
  return onGroupPaymentCollectionCreate(params)
    .then((response) => {
      dispatch(createGroupPaymentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupPayment >>>> storableError(e)")
      dispatch(createGroupPaymentError(storableError(e)));
      return e;
    });
};


export const updateGroupPayment = (params,loader) => async (dispatch, getState) => {
  dispatch(updateGroupPaymentRequest(loader));
  return onGroupPaymentCollectionUpdate(params)
    .then((response) => {
      dispatch(updateGroupPaymentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "updateGroupPayment >>>> storableError(e)")
      dispatch(updateGroupPaymentError(storableError(e)));
      return e;
    });
};


const normalizeGroupFolderParams = params => ({
  ...params,
  payload: {
    ...params.payload,
    groupId: String(params.payload?.groupId),
  },
});

export const createGroupFolder = (params, groupId) => async (dispatch, getState) => {
  const resolvedGroupId = String(groupId ?? params?.payload?.groupId);
  const createParams = {
    ...params,
    payload: {
      ...params.payload,
      groupId: resolvedGroupId,
    },
  };

  dispatch(createFolderRequest("create"));
  return onGroupFolderCollectionCreate(createParams)
    .then(async (response) => {
      await dispatch(fetchGroupFolder({
        payload: {
          groupId: resolvedGroupId,
          isActive: true,
          isDelete: false
        }
      }))
      dispatch(createFolderSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(createFolderError(storableError(e)));
    });
};

export const updateGroupFolder = (params, groupId) => async (dispatch, getState) => {
  const type = !!params.payload.isDelete ? "delete" : "update"
  const resolvedGroupId = String(groupId ?? params?.payload?.groupId);
  dispatch(updateFolderRequest(type));
  return onGroupFolderCollectionUpdate(params)
    .then(async (response) => {
      await dispatch(fetchGroupFolder({
        payload: {
          groupId: resolvedGroupId,
          isActive: true,
          isDelete: false
        }
      }))
      dispatch(updateFolderSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(updateFolderError(storableError(e)));
    });
};

export const fetchGroupFolder = (params) => async (dispatch, getState) => {
  dispatch(fetchFolderRequest());
  return onGroupFolderCollectionFind(normalizeGroupFolderParams(params))
    .then((response) => {
      dispatch(fetchFolderSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(fetchFolderError(storableError(e)));
    });
};


export const updateGroupDocumentFolder = (params, fetchData) => async (dispatch, getState) => {
  dispatch(updateFolderDocumentRequest(params.id));
  return onGroupFolderDocumentCollectionUpdate(params)
    .then(async (response) => {
      await dispatch(fetchGroupDocumentFolder(fetchData))
      dispatch(updateFolderDocumentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(updateFolderDocumentError(storableError(e)));
    });
};

export const fetchGroupDocumentFolder = (params) => async (dispatch, getState) => {
  dispatch(fetchFolderDocumentRequest());
  return onGroupFolderDocumentCollectionFind(params)
    .then((response) => {
      dispatch(fetchFolderDocumentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(fetchFolderDocumentError(storableError(e)));
    });
};

const getLoadedGroupId = getState =>
  getState().CircleCommunityPage?.spaceDetailsData?.spaceDetail?.id;

export const loadGroupPageTabData = (tab, groupId) => async (dispatch, getState) => {
  const currentUserId = getState().user.currentUser?.id?.uuid;
  switch (tab) {
    case GROUP_PAGE_TAB_DOCUMENTS:
      return dispatch(
        fetchGroupFolder({
          payload: {
            groupId,
            isActive: true,
            isDelete: false,
          },
        })
      );
    case GROUP_PAGE_TAB_PAYMENTS:
      return dispatch(
        fetchGroupPayment(
          {
            payload: {
              groupId: String(groupId),
              status: GROUP_PAYMENT_STATUS_ACTIVE,
            },
            pageParams: {
              page: 1,
              perPage: GROUP_PAYMENT_PAGE_SIZE,
            },
          },
          { userId: currentUserId }
        )
      );
    default:
      return null;
  }
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const { page = 1, topicId } = parse(search);
  const groupId = params.groupId || params.id;
  const tab = resolveGroupPageTab(search);
  const loadedGroupId = getLoadedGroupId(getState);

  // Tab switches update ?tab= in the URL, which retriggers loadData. Skip the full
  // page shell reload when we already have this group loaded.
  if (loadedGroupId != null && String(loadedGroupId) === String(groupId)) {
    return dispatch(loadGroupPageTabData(tab, groupId));
  }

  dispatch(requestSpaceDetails(page));

  return Promise.all([dispatch(fetchCurrentUser())])
    .then(async response => {
      // Get the current user's data from state
      const currentUser = getState().user.currentUser;
      const email = currentUser?.attributes?.email;

      // Get the community data from state
      const { spaceListData } = getState().CircleCommunityPage;

      if (email) {
        // fetch auth token on first load
        await setInitalLoadToken(getCurrentUserCircleAuthParams(currentUser));
        const promisify = [
          dispatch(getSpaceDetails({ spaceId: groupId, page: +page, topicId })),
          dispatch(toggleCreateComment(false)),
          dispatch(fetchGroupFolder({
            payload: {
              groupId,
              isActive: true,
              isDelete: false,
            },
          })),
        ];

        promisify.push(dispatch(findGroupJoin({
          email,
          spaceId: groupId,
        })));

        // ✅ Fetch Admin and Moderator
        promisify.push(dispatch(fetchAdminModerator({
          payload: {
            groupId,
            status: 'active',
            role: 'admin',
          },
        })));
        promisify.push(dispatch(
          fetchGroupPayment(
            {
              payload: {
                groupId: String(groupId),
                status: GROUP_PAYMENT_STATUS_ACTIVE,
              },
              pageParams: {
                page: 1,
                perPage: GROUP_PAYMENT_PAGE_SIZE,
              },
            },
            { userId: currentUser?.id?.uuid }
          )
        ));

        promisify.push(dispatch(fetchGroupHighlightsStatus(groupId)));

        if (!spaceListData || (spaceListData && spaceListData.length == 0)) promisify.push(dispatch(fetchSpaceList()));
        await Promise.all(promisify);
      }
      return response;
    })
    .catch(e => {
      throw e;
    });
};
